import React from 'react';
import './style.css';

export const SelectionNoLongerAvailable = (props) => {
    const { closeMessage } = props;

    return (
        <div className="stake-exceed-message">
            <div className="stake-exceed-message-header">
                <span className="stake-exceed-message-title">Selection unavailable</span>
                <button
                    className="stake-exceed-message-close"
                    onClick={closeMessage}>
                    ×
                </button>
            </div>
            <div className="stake-exceed-message-wrapper">
                <div className="stake-exceed-message-body">
                    <img src="/images/warningIcon.png" alt="type"></img>
                    <span>Selection is no longer available.</span>
                </div>
                <div className="stake-exceed-message-footer">
                    <p>Press Ok to go back</p>
                </div>
                <div className="stake-exceed-message-buttons">
                    <button
                        className="message-button"
                        onClick={closeMessage}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};